var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoOutlined } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Alert, AlertTitle, Box, Button, Chip } from '@mui/material';
import { blue } from '@mui/material/colors';
import { useMemo, useState } from 'react';
import CardOperador from '../../../components/Operador/CardOperador';
import { OperadorModalForm } from '../../../components/Operador/OperadorModalForm';
import { WizardButtons } from '../../../components/Wizard/WizardButtons';
import { useWizard } from '../../../components/Wizard/useWizard';
import { EntidadeAnalise } from '../../../enums/analise.enum';
import { getStatusEntidade } from '../../../util/analise.utils';
import { useProcessContext } from '../context/ProcessContext';
export var OperadoresForm = function (_a) {
    var _b, _c;
    var disabled = _a.disabled;
    var _d = useWizard(), nextStep = _d.nextStep, prevStep = _d.prevStep;
    var _e = useState(null), modalOperadorOpen = _e[0], setModalOperadorOpen = _e[1];
    var _f = useState(undefined), selectedOperador = _f[0], setSelectedOperador = _f[1];
    var _g = useProcessContext(), servico = _g.servico, analise = _g.analise, addOperador = _g.addOperador, updateOperador = _g.updateOperador, deleteOperador = _g.deleteOperador, processo = _g.processo, isLoading = _g.isLoading;
    var operadores = (_c = (_b = processo === null || processo === void 0 ? void 0 : processo.empresa) === null || _b === void 0 ? void 0 : _b.operadores) !== null && _c !== void 0 ? _c : [];
    var analiseStatusEntidades = useMemo(function () { return getStatusEntidade(EntidadeAnalise.OPERADOR, analise === null || analise === void 0 ? void 0 : analise.gruposCampos); }, [analise === null || analise === void 0 ? void 0 : analise.gruposCampos]);
    var handleOpenAdd = function () {
        setModalOperadorOpen('adicionar');
    };
    var handleOpenEdit = function (operador) {
        setSelectedOperador(operador);
        setModalOperadorOpen('editar');
    };
    var handleOpenView = function (operador) {
        setSelectedOperador(operador);
        setModalOperadorOpen('visualizar');
    };
    var handleCloseModal = function () {
        setSelectedOperador(undefined);
        setModalOperadorOpen(null);
    };
    var handleDelete = function (operadorId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteOperador(operadorId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveOperador = function (operador) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedOperador) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateOperador(selectedOperador.id, operador)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, addOperador(operador)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setModalOperadorOpen(null);
                    setSelectedOperador(undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    if (!(servico === null || servico === void 0 ? void 0 : servico.exigeOperador)) {
        return null;
    }
    var atingiuMaximo = servico.numeroMaximoOperadores <= (operadores === null || operadores === void 0 ? void 0 : operadores.length);
    return (_jsxs(Box, { children: [_jsx(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 1,
                }, children: !disabled && (_jsxs(_Fragment, { children: [atingiuMaximo && (_jsx(Chip, { size: "small", sx: {
                                backgroundColor: blue[50],
                                color: blue[600],
                                fontWeight: 500,
                            }, icon: _jsx(InfoOutlined, { color: "inherit" }), label: "Atingiu o n\u00FAmero m\u00E1ximo de \"".concat(servico.numeroMaximoOperadores, "\" operadores") })), _jsx(Button, { variant: "contained", color: "primary", startIcon: _jsx(AddIcon, {}), onClick: handleOpenAdd, disabled: atingiuMaximo, children: "Adicionar Operador(a)" })] })) }), !(operadores === null || operadores === void 0 ? void 0 : operadores.length) && (_jsxs(Alert, { severity: "warning", sx: { mt: 2 }, children: [_jsx(AlertTitle, { children: "Voc\u00EA ainda n\u00E3o realizou o cadastro de nenhum Operador(a)." }), "Clique no bot\u00E3o", _jsx(Button, { color: "inherit", size: "small", onClick: handleOpenAdd, children: "Adicionar Operador(a)" }), "para cadastrar Operador(as)."] })), !!(operadores === null || operadores === void 0 ? void 0 : operadores.length) &&
                operadores.map(function (operador) { return (_jsx(CardOperador, { operador: operador, status: analiseStatusEntidades[operador.id], onOpenEdit: handleOpenEdit, onOpenView: handleOpenView, onDelete: handleDelete, disabled: disabled }, operador.id)); }), !!modalOperadorOpen && (_jsx(OperadorModalForm, { modo: modalOperadorOpen, open: true, operador: selectedOperador, analise: analise, onClose: handleCloseModal, onSave: handleSaveOperador })), _jsx(WizardButtons, { nextClick: function () { return nextStep(); }, prevClick: function () { return prevStep(); }, isSubmitting: isLoading })] }));
};
